import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@y365/design-system/styles.css';
import './styles/app.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
